import React from "react";
import "./DiwaliOffer.css";

/* ============================================================
   Diwali Special Offer — Flat 20% OFF
     <DiwaliBanner />  — full-width banner directly below the site header
     <Diya />          — small animated oil-lamp illustration
     <DiwaliNote />    — offer reminder beside the fee-section enrol buttons
   Helpers: DIWALI_OFF_PCT, diwaliPrice(fee), formatINR(n)
   Palette: deep navy → royal purple with gold accents.
   ============================================================ */

export const DIWALI_OFF_PCT = 20;
export const diwaliPrice = (fee) => Math.round(fee * (1 - DIWALI_OFF_PCT / 100));
export const formatINR = (n) => "₹" + Number(n).toLocaleString("en-IN");

export const Diya = ({ className = "" }) => (
  <svg className={`lm-diya ${className}`} viewBox="0 0 64 64" aria-hidden="true" focusable="false">
    <circle className="lm-diya__glow" cx="32" cy="24" r="20" fill="#ffd77a" />
    <g className="lm-diya__flame">
      <path d="M32 8c4.5 6 6.5 10 6.5 13.5A6.5 6.5 0 0 1 32 28a6.5 6.5 0 0 1-6.5-6.5C25.5 18 27.5 14 32 8z" fill="#ffb938" />
      <path d="M32 15c2.2 3.2 3.2 5.4 3.2 7.2a3.2 3.2 0 0 1-6.4 0c0-1.8 1-4 3.2-7.2z" fill="#fff3c4" />
    </g>
    <path d="M8 34h48c0 10-10.7 18-24 18S8 44 8 34z" fill="#e0a73c" />
    <path d="M8 34h48" stroke="#ffe7a8" strokeWidth="2" strokeLinecap="round" />
    <path d="M18 41c4 3 9 4.5 14 4.5s10-1.5 14-4.5" fill="none" stroke="#8a5a14" strokeWidth="1.6" strokeLinecap="round" opacity=".55" />
  </svg>
);

export const DiwaliBanner = () => (
  <section className="lm-diwali" aria-label="Diwali Special Offer: flat 20% off">
    <span className="lm-diwali__glow" aria-hidden="true" />
    <Diya className="lm-diwali__diya lm-diwali__diya--l" />
    <Diya className="lm-diwali__diya lm-diwali__diya--r" />
    <div className="lm-diwali__inner">
      <p className="lm-diwali__pct">
        <span className="lm-diwali__flat">Flat</span>
        <strong>{DIWALI_OFF_PCT}% OFF</strong>
      </p>
      <div className="lm-diwali__copy">
        <p className="lm-diwali__title">Diwali Special Offer</p>
        <p className="lm-diwali__sub">Celebrate Diwali by investing in your future.</p>
      </div>
      <a className="lm-diwali__cta" href="#LiveCourse">
        Explore Courses
        <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10h11M11 5l5 5-5 5" /></svg>
      </a>
    </div>
  </section>
);

/* Struck-through original fee + Diwali price for the course cards. */
export const DiwaliCardFee = ({ fee }) => (
  <div className="plc_fee_row lm-dfee">
    <span className="plc_fee_label">Course Fee</span>
    <s className="plc_fee_original">
      <span className="lm-sr">Original price </span>
      {formatINR(fee)}
    </s>
    <span className="plc_fee_current">{formatINR(diwaliPrice(fee))}</span>
    <span className="lm-dfee__tag">
      <Diya />
      Diwali {DIWALI_OFF_PCT}% OFF
    </span>
  </div>
);

/* Offer reminder that sits beside the fee-section enrolment buttons. */
export const DiwaliNote = ({ fee }) => (
  <p className="lm-dnote">
    <Diya className="lm-dnote__diya" />
    <span>
      <b>Diwali Special Offer: Flat {DIWALI_OFF_PCT}% OFF</b> — pay{" "}
      <b>{formatINR(diwaliPrice(fee))}</b>
      <s>
        <span className="lm-sr">instead of </span>
        {formatINR(fee)}
      </s>
    </span>
  </p>
);

export default DiwaliBanner;
